export const TABS = {
	INCREMENT_ACTIVE_INDEX: 'TABS_ INCREMENT_ACTIVE_INDEX ',
	DECREMENT_ACTIVE_INDEX: 'TABS_DECREMENT_ACTIVE_INDEX',
	RESET_ACTIVE_INDEX: 'TABS_RESET_ACTIVE_INDEX',
};
